let backendHost;
const hostname = window && window.location && window.location.hostname;
let localhost;
let orderPort;
let userPort;

if (hostname.indexOf('ecs-load-balancer') > -1 || hostname.indexOf('tracking.bestway.co.uk') > -1) {
  backendHost = `https://${hostname}`;
  localhost = false;
  orderPort = 8888;
  userPort = 9090;
} else if (hostname === 'localhost') {
  backendHost = 'http://localhost:3000/data';
  localhost = true;
} else {
  backendHost = process.env.REACT_APP_BACKEND_HOST || 'http://localhost:3000';
  localhost = true;
}

export const API_ROOT = `${backendHost}`;
export const IS_LOCALHOST = localhost;
export const ORDER_PORT = orderPort;
export const USER_PORT = userPort;

const headers = { 'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json' };

export const config = {
  headers,
  withCredentials: true,
};




// WEBPACK FOOTER //
// src/configs/environments.js